import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
   providedIn: 'root'
})

export class MetaService {
   constructor(@Inject(DOCUMENT) private dom) { }

   createCanonicalURL() {
     if(document.querySelector("link[rel='canonical']") && document.querySelector("link[rel='canonical']").getAttribute("href")) {
      document.querySelector("link[rel='canonical']").setAttribute("href", this.dom.URL);
     } else {
      let link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);
      link.setAttribute('href', this.dom.URL);
     }

   }
}
